module.exports = __webpack_public_path__ + "img/de.a2ff6d85.svg";